<template>
  <modal :modal-key="'resubscribe_with_pin'" class="modal--welcomeback modal--zero-balance " @close="$emit('close')">
    <template slot="header">
        <h1>{{ getTranslations.home_modals_profile_email_submit_submit_email }}</h1>
        <img class="pinicon mt-1" src="static/images/email_submit.svg" alt="">
      </template>
    <template slot="body">


        <form action="">
          <div :class="['form-group sml_mrgn', hasErrors ? 'has-warning' : '']">
            <input type="text"
                   v-model="email"
                   @keyup="validateEmail($event)"
                   class="form-group__textfield email_submit"
                   :placeholder="getTranslations.home_modals_profile_email_submit_placeholder" />
            <!--<span class="form-group__feedback">$#Oops!Error message</span> -->
            <span class="form-group__feedback"
                  v-if="hasErrors && buttonErrorSubmit">
               {{ getMessage }}
              </span>
            <span class="form-group__feedback"
                  v-if="secondValidationError && hasErrors && !buttonErrorSubmit">
               {{ getTranslations.home_modals_change_error }}
              </span>
          </div>
          <input type="submit"
                 :value="getTranslations.home_modals_profile_email_submit_submit"
                 @click.prevent="updateEmailAction()"
                 :class="['btn2 btn2--std btn2--small btn2--fixed', hasErrors || !email ? 'deactivated' : '']">
          <!-- <div  class="success_msg"><p>Invitation successfully sent!
          </p></div> --> <!-- add div success_msg if user completed the action -->
        </form>

      </template>
  </modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import EmailThankYou from '@/components/home/modals/profile/EmailThankYou';
import ValidationMixin from '@/common/mixins/validations';

export default {
  name: 'email-submit',
  mixins: [ValidationMixin],
  data() {
    return {
      buttonErrorSubmit: false,
    };
  },
  components: {
    Modal,
    EmailThankYou,
  },
  methods: {
    ...mapActions('profile', [
      'registerEmail',
      'storeLoginInfo',
    ]),
    ...mapMutations('common', [
      'updateEmailVerified',
      'storeModalForHomePage',
      'emptyActiveModalsStack',
    ]),
    updateEmailAction() {
      this.buttonErrorSubmit = false;
      if (this.email.includes('@@') || this.email.includes('..')) {
        this.secondValidationError = true;
        this.hasErrors = true;
      }
      if (this.email && !this.hasErrors && !this.secondValidationError) {
        this.registerEmail({ email: this.email }).then((response) => {
          const res = response.data.responseEnum;
          if (res === 'OPERATION_SUCCESS') {
            this.updateEmailVerified(true);
            this.storeModalForHomePage(null);
            this.clearMessages();
            this.$emit('close');
            this.storeModalForHomePage(EmailThankYou);
          } else {
            this.setError(true);
            this.buttonErrorSubmit = true;
            this.setResult('home_modals_change_email_error');
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslationByOperator',
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/profile/EmailSubmit.vue